import { formatDate } from '../../utils/dateUtilities';

const TimestampFormatter = ({ value }) => {
  if (!value) return '';
  return formatDate(value);
};

export default TimestampFormatter;
